function adjustContrast(background, foreground){
    var backgroundLuminance = luminance(background);
    var foregroundLuminance = luminance(foreground);
    var foregroundLighter = foregroundLuminance > backgroundLuminance;
    var l1 = foregroundLighter ? foregroundLuminance : backgroundLuminance;
    var l2 = foregroundLighter ? backgroundLuminance : foregroundLuminance;
    var contrast = (l1 + 0.05)/(l2 + 0.05);

    if (contrast >= 4.5) return foreground;

    var foregroundHex = Plastic.ColorConvert.fromTo(foreground, "hex");
    if (foregroundHex === "#ffffff" || foregroundHex === "#000000"){
        // Future: Check if opposite would be better
        return foreground;
    }
    else {
        if (foregroundLighter) foreground = lighter(foreground);
        else foreground = darker(foreground);
        return adjustContrast(background, foreground);
    }

    function darker(color){
        var type = Plastic.ColorConvert.getColorType(color);
        var hsl = Plastic.ColorConvert.fromTo(color, "hsl", "obj");
        hsl["s"] = Math.min(Math.max(hsl["s"] + 1, 0), 100);
        hsl["l"] = Math.min(Math.max(hsl["l"] - 1, 0), 100);
        return Plastic.ColorConvert.fromTo(hsl, type);
    }
    function lighter(color){
        var type = Plastic.ColorConvert.getColorType(color);
        var hsl = Plastic.ColorConvert.fromTo(color, "hsl", "obj");
        hsl["s"] = Math.min(Math.max(hsl["s"] - 1, 0), 100);
        hsl["l"] = Math.min(Math.max(hsl["l"] + 1, 0), 100);
        return Plastic.ColorConvert.fromTo(hsl, type);
    }
}
function calculateContrast(color1, color2) {
    color1 = luminance(color1);
    color2 = luminance(color2);

    var brighter    = Math.max(color1, color2);
    var darker      = Math.min(color1, color2);

    return (brighter + .05) / (darker + .05);
}
function changeOpacity(color, opacity){
    var type = Plastic.ColorConvert.getColorType(color);
    var rgb = Plastic.ColorConvert.fromTo(color, "rgb", "obj");
    rgb["a"] = opacity;
    return Plastic.ColorConvert.fromTo(rgb, type);
}
function contrast(hex){
    var rgb = Plastic.ColorConvert.fromTo(hex, "rgb", "obj");
    var contrast = ((rgb["r"] * 299) + (rgb["g"] * 587) + (rgb["b"] * 114)) / 1000;
    return rgb["a"] === 0 || contrast > 130 ? "#000" : "#fff";
}
function darken(color, amount){
    if (isEmpty(amount)) return color;

    amount = parseFloat(amount);
    amount = amount < 1 && amount > -1 ? amount * 100 : amount;

    var type = Plastic.ColorConvert.getColorType(color);
    var hsl = Plastic.ColorConvert.fromTo(color, "hsl", "obj");
    hsl["l"] = Math.min(Math.max(hsl["l"] - amount, 0), 100);
    return Plastic.ColorConvert.fromTo(hsl, type);
}
function fromTo(input, toType, returnType){
    var fromType = getColorType(input);
    if (fromType === "unknown") return;
    if (fromType === toType) {
        var tmpType = fromType === "rgb" ? "hsv" : "rgb";
        var tmpColor = fromTo(input, tmpType);
        return fromTo(tmpColor, toType, returnType);
    }
    return Plastic.ColorConvert[`${fromType}To`][toType](input, returnType);
}
function getAll(input, inputType, returnType){
    if (!validInput(input, inputType)) return;
    var output = {};
    var types = ["cmyk", "hex", "hsl", "hsv", "pantone", "rgb"];
    forLoop(types, type => {
        if (type === inputType) {
            if (returnType === "obj") output[type] = ifSetCall(Plastic.ColorConvert[`${type}To`]["obj"], input);
            else output[type] = ifSetCall(Plastic.ColorConvert[`${type}To`]["str"], input);
            output[type] = isPresentOr(output[type], input);
        }
        else output[type] = Plastic.ColorConvert[`${inputType}To`][type](input, returnType);
    });
    return output;
}
function getColorType(color){
    if (isUndefined(color)) return "unknown";
    if (isPlainObject(color)){
        if (includes(["h", "s", "l"], Object.keys(color), true)) return "hsl";
        if (includes(["h", "s", "v"], Object.keys(color), true)) return "hsv";
        if (includes(["r", "g", "b"], Object.keys(color), true)) return "rgb";
        if (includes(["c", "m", "y", "k"], Object.keys(color), true)) return "cmyk";
        if (includes("hsv", Object.keys(color))) return "hsv";
        if (includes("rgb", Object.keys(color))) return "rgb";
        if (includes("cmyk", Object.keys(color))) return "cmyk";
        return "unknown";
    }

    if (includes("#", color)) return "hex";
    else if (includes("hsl", color)) return "hsl";
    else if (includes("hsv", color)) return "hsv";
    else if (includes("rgb", color)) return "rgb";
    else if (includes("cmyk", color)) return "cmyk";

    var pantone = pantoneTo.hex(color);
    return isPresent(pantone) ? "pantone" : "unknown";
}
function lighten(color, amount){
    if (isEmpty(amount)) return color;

    amount = parseFloat(amount);
    amount = amount < 1 && amount > -1 ? amount * 100 : amount;

    var type = Plastic.ColorConvert.getColorType(color);
    var hsl = Plastic.ColorConvert.fromTo(color, "hsl", "obj");
    hsl["l"] = Math.max(Math.min(hsl["l"] + amount, 100), 0);
    return Plastic.ColorConvert.fromTo(hsl, type);
}
function luminance(color){
    var rgb = Plastic.ColorConvert.fromTo(color, "rgb", "obj");
    var r = rgb["r"] / 255;
    var g = rgb["g"] / 255;
    var b = rgb["b"] / 255;
    r = r <= 0.03928 ? r / 12.92 : Math.pow((r + 0.055)/1.055, 2.4);
    g = g <= 0.03928 ? g / 12.92 : Math.pow((g + 0.055)/1.055, 2.4);
    b = b <= 0.03928 ? b / 12.92 : Math.pow((b + 0.055)/1.055, 2.4);
    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}
function parse(input){
    var isCMYK = input.indexOf("cmyk") >= 0;
    var codeCount = isCMYK ? 4 : 3;

    var characters = ["hsla", "hsl", "hsv", "device-cmyk", "cmyk", "rgba", "rgb", "(", ")"];
    input = removeChar(input, characters);

    var [color, alpha] = input.split("/");
    color = color.trim();

    var hasCommas = includes(",", color);
    var delimiter = hasCommas ? "," : " ";

    color = color.split(delimiter);

    if (isPresent(alpha)){
        if (includes(",", alpha)){
            alpha = alpha.split(",")[0]; // ignore fallback (cmyk)
        }
        alpha = parseAlpha(alpha);
        if (isPresent(alpha)) color.push(alpha);
    }
    else if (color.length > codeCount){
        color[codeCount] = parseAlpha(color[codeCount]);
    }

    for (var i = 0; i < codeCount; i++){
        color[i] = parseInt(color[i]);
    }

    return color;
}
function parseAlpha(alpha){
    alpha = parseFloat(alpha);
    if (isNaN(alpha)) return;
    if (alpha < 0) return;
    if (alpha > 100) return;
    if (alpha > 1) return alpha / 100;
    return alpha;
}
function validInput(input, type){
    if (isEmpty(input)) return false;
    if (type === "hex"){
        return includes(input.length, [4, 7, 9]); // (3, 6 or 8) + "#"
    }
    if (!includes(type, ["hsl", "hsv", "rgb", "cmyk"])) return true;

    var obj = Plastic.ColorConvert[`${type}To`]["obj"](input);
    switch(type){
        case "hsl": return objHasAll(obj, ["h", "s", "l"]);
        case "hsv": return objHasAll(obj, ["h", "s", "v"]);
        case "rgb": return objHasAll(obj, ["r", "g", "b"]);
        case "cmyk": return objHasAll(obj, ["c", "m", "y", "k"]);
    }
}

const cmykTo = {
    all: function(input, returnType){
        return getAll(input, "cmyk", returnType);
    },
    arr: function(input){
        if (isString(input)) input = cmykTo.obj(input);
        var output = [input["c"], input["m"], input["y"], input["k"]];
        if (isPresent(input["a"])) output.push(input["a"]);
        return output;
    },
    hex: function(input){
        if (!validInput(input, "cmyk")) return;
        var rgb = cmykTo.rgb(input);
        return rgbTo.hex(rgb);
    },
    hsl: function(input, returnType){
        if (!validInput(input, "cmyk")) return;
        var rgb = cmykTo.rgb(input);
        return rgbTo.hsl(rgb, returnType);
    },
    hsv: function(input, returnType){
        if (!validInput(input, "cmyk")) return;
        var rgb = cmykTo.rgb(input);
        return rgbTo.hsv(rgb, returnType);
    },
    obj: function(input){
        if (isPlainObject(input)) return input;
        var [c, m, y, k, a] = parse(input);
        return {c:c, m:m, y:y, k:k, a:a};
    },
    pantone: function(input){
        if (!validInput(input, "cmyk")) return;
        var hex = cmykTo.hex(input);
        return hexTo.pantone(hex);
    },
    rgb: function(input, returnType){
        var [c, m, y, k, a] = rgbTo.arr(input);

        var cyan    = Math.max(Math.min(parseInt(c, 10) / 100, 1), 0);
        var magenta = Math.max(Math.min(parseInt(m, 10) / 100, 1), 0);
        var yellow  = Math.max(Math.min(parseInt(y, 10) / 100, 1), 0);
        var black   = Math.max(Math.min(parseInt(k, 10) / 100, 1), 0);
        var red     = (1 - cyan     * (1 - black) - black);
        var green   = (1 - magenta  * (1 - black) - black);
        var blue    = (1 - yellow   * (1 - black) - black);
        var output = {
            r: Math.round(red * 255),
            g: Math.round(green * 255),
            b: Math.round(blue * 255),
            a: a
        };

        if (returnType === "obj") return output;
        else return rgbTo.str(output);
    },
    str: function(obj){
        if (isString(obj)) obj = parse(obj);
        if (!objHasAll(obj, ["c", "m", "y", "k"])) return "";
        var str = `cmyk(${obj["c"]}, ${obj["m"]}, ${obj["y"]}, ${obj["k"]}`;
        if (isPresent(obj["a"])) str += ` / ${obj["a"]}`;
        str += ")"
        return str;
    }
};
const hexTo = {
    all: function(input, returnType){
        return getAll(input, "hex", returnType);
    },
    cmyk: function(input, returnType){
        if (!validInput(input, "hex")) return;
        var rgb = hexTo.rgb(input);
        return rgbTo.cmyk(rgb, returnType);
    },
    hsl: function(input, returnType){
        if (!validInput(input, "hex")) return;
        var rgb = hexTo.rgb(input);
        return rgbTo.hsl(rgb, returnType);
    },
    hsv: function(input, returnType){
        if (!validInput(input, "hex")) return;
        var rgb = hexTo.rgb(input);
        return rgbTo.hsv(rgb, returnType);
    },
    pantone: function(hex){
        if (hex[0] === "#") hex = hex.substr(1);
        var match = "";
        loopProps(Plastic.ColorConvert.PantoneColors, (name, color) => {
            if (color["hex"] === hex){
                match = color["name"];
                return true;
            }
        });
        return match;
    },
    rgb: function(hex, returnType){
        if (hex[0] === "#") hex = hex.substr(1);
        var rgb = {};

        switch(hex.length){
            case 3:
                rgb["r"] = hexToDec(`${hex[0]}${hex[0]}`);
                rgb["g"] = hexToDec(`${hex[1]}${hex[1]}`);
                rgb["b"] = hexToDec(`${hex[2]}${hex[2]}`);
                break;
            case 8:
                rgb["a"] = round(hexToDec(`${hex[6]}${hex[7]}`)/255);
            case 6:
                rgb["r"] = hexToDec(`${hex[0]}${hex[1]}`);
                rgb["g"] = hexToDec(`${hex[2]}${hex[3]}`);
                rgb["b"] = hexToDec(`${hex[4]}${hex[5]}`);
                break;
        }
        if (returnType === "obj") return rgb;
        else return rgbTo.str(rgb);

        function hexToDec(hex){return parseInt(hex, 16);}
    }
};
const hslTo = {
    all: function(input, returnType){
        return getAll(input, "hsl", returnType);
    },
    arr: function(input){
        if (isString(input)) input = hslTo.obj(input);
        var output = [input["h"], input["s"], input["l"]];
        if (isPresent(input["a"])) output.push(input["a"]);
        return output;
    },
    cmyk: function(input, returnType){
        if (!validInput(input, "hsl")) return;
        var rgb = hslTo.rgb(input);
        return rgbTo.cmyk(rgb, returnType);
    },
    hex: function(input){
        if (!validInput(input, "hsl")) return;
        var rgb = hslTo.rgb(input);
        return rgbTo.hex(rgb);
    },
    hsv: function(input, returnType){
        if (!validInput(input, "hsl")) return;
        var rgb = hslTo.rgb(input);
        return rgbTo.hsv(rgb, returnType);
    },
    obj: function(input){
        if (isPlainObject(input)) return input;
        var [h, s, l, a] = parse(input);
        return {h:h, s:s, l:l, a:a};
    },
    pantone: function(input){
        if (!validInput(input, "hsl")) return;
        var hex = hslTo.hex(input);
        return hexTo.pantone(hex);
    },
    rgb: function(input, returnType){
        var [h, s, l, a] = hslTo.arr(input);

        h = Math.max(Math.min(parseInt(h, 10), 360), 0) / 360;
        s = Math.max(Math.min(parseInt(s, 10), 100), 0) / 100;
        l = Math.max(Math.min(parseInt(l, 10), 100), 0) / 100;

        var r, g, b;
        if (s === 0) r = g = b = l; // achromatic
        else {
            var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
            var p = 2 * l - q;

            r = hue2rgb(p, q, h + 1/3);
            g = hue2rgb(p, q, h);
            b = hue2rgb(p, q, h - 1/3);
        }

        var output = {
            r: Math.round(r * 255),
            g: Math.round(g * 255),
            b: Math.round(b * 255),
            a: parseAlpha(a)
        };

        if (returnType === "obj") return output;
        else return rgbTo.str(output);

        function hue2rgb(p, q, t) {
            if (t < 0) t += 1;
            if (t > 1) t -= 1;
            if (t < 1/6) return p + (q - p) * 6 * t;
            if (t < 1/2) return q;
            if (t < 2/3) return p + (q - p) * (2/3 - t) * 6;
            return p;
        }
    },
    str: function(obj){
        if (isString(obj)) obj = parse(obj);
        if (!objHasAll(obj, ["h", "s", "l"])) return "";
        var str = `hsl(${obj["h"]}, ${obj["s"]}%, ${obj["l"]}%`;
        if (isPresent(obj["a"])) str += `, ${obj["a"]}`;
        str += ")"
        return str;
    }
};
const hsvTo = {
    all: function(input, returnType){
        return getAll(input, "hsv", returnType);
    },
    arr: function(input){
        if (isString(input)) input = hsvTo.obj(input);
        var output = [input["h"], input["s"], input["v"]];
        if (isPresent(input["a"])) output.push(input["a"]);
        return output;
    },
    cmyk: function(input, returnType){
        if (!validInput(input, "hsv")) return;
        var rgb = hsvTo.rgb(input);
        return rgbTo.cmyk(rgb, returnType);
    },
    hex: function(input){
        if (!validInput(input, "hsv")) return;
        var rgb = hsvTo.rgb(input);
        return rgbTo.hex(rgb);
    },
    hsl: function(input, returnType){
        if (!validInput(input, "hsv")) return;
        var rgb = hsvTo.rgb(input);
        return rgbTo.hsl(rgb, returnType);
    },
    obj: function(input){
        if (isPlainObject(input)) return input;
        var [h, s, v, a] = parse(input);
        return {h:h, s:s, v:v, a:a};
    },
    pantone: function(input){
        if (!validInput(input, "hsv")) return;
        var hex = hsvTo.hex(input);
        return hexTo.pantone(hex);
    },
    rgb: function(input, returnType){
        var [h, s, v, a] = hsvTo.arr(input);

        h = parseFloat(h);
        s = parseFloat(s);
        v = parseFloat(v);
        h = h > 1 ? h / 360 : h;
        s = s > 1 ? s / 100 : s;
        v = v > 1 ? v / 100 : v;

        var r, g, b;
        var i = Math.floor(h * 6);
        var f = h * 6 - i;
        var p = v * (1 - s);
        var q = v * (1 - f * s);
        var t = v * (1 - (1 - f) * s);

        switch (i % 6) {
            case 0: r = v; g = t; b = p; break;
            case 1: r = q; g = v; b = p; break;
            case 2: r = p; g = v; b = t; break;
            case 3: r = p; g = q; b = v; break;
            case 4: r = t; g = p; b = v; break;
            case 5: r = v; g = p; b = q; break;
        }

        var output = {
            r: r * 255,
            g: g * 255,
            b: b * 255,
            a: a
        };
        if (returnType === "obj") return output;
        else return rgbTo.str(output);
    },
    str: function(obj){
        if (isString(obj)) obj = parse(obj);
        if (anyEmpty(obj["h"], obj["s"], obj["v"])) return "";
        var h = obj["h"] > 1 ? obj["h"] : obj["h"] * 360;
        var s = obj["s"] > 1 ? obj["s"] : obj["s"] * 100;
        var v = obj["v"] > 1 ? obj["v"] : obj["v"] * 100;
        var str = `hsv(${round(h, 0)}, ${round(s, 0)}%, ${round(v, 0)}%`;
        if (isPresent(obj["a"])) str += ` / ${obj["a"]}`;
        str += ")"
        return str;
    }
};
const pantoneTo = {
    all: function(input, returnType){
        return getAll(input, "pantone", returnType);
    },
    cmyk: function(input, returnType){
        var hex = pantoneTo.hex(input);
        if (isEmpty(hex)) return;
        return hexTo.cmyk(hex, returnType);
    },
    hex: function(pantone){
        const PantoneColors = Plastic.ColorConvert.PantoneColors;
        var hex;
        if (isDefined(PantoneColors[pantone])) hex = PantoneColors[pantone].hex;
        else {
            pantone = pantone.toLowerCase().replace(" ", "-");
            var numeric = `${numbers(pantone, true)}c`;
            loopProps(PantoneColors, function(name){
                var keyMatch = PantoneColors[name].name === pantone;
                var nameMatch = PantoneColors[name].name.replace("-", "") === pantone;
                var numericMatch = PantoneColors[name].name.replace("-", "") === numeric;
                if (keyMatch || nameMatch || numericMatch){
                    hex = PantoneColors[name].hex;
                    return true;
                }
            });
        }
        return isPresent(hex) ? `#${hex}` : null;
    },
    hsl: function(input, returnType){
        var hex = pantoneTo.hex(input);
        if (isEmpty(hex)) return;
        return hexTo.hsl(hex, returnType);
    },
    hsv: function(input, returnType){
        var hex = pantoneTo.hex(input);
        if (isEmpty(hex)) return;
        return hexTo.hsv(hex, returnType);
    },
    rgb: function(input, returnType){
        var hex = pantoneTo.hex(input);
        if (isEmpty(hex)) return;
        return hexTo.rgb(hex, returnType);
    },
};
const rgbTo = {
    all: function(input, returnType){
        return getAll(input, "rgb", returnType);
    },
    arr: function(input){
        if (isString(input)) input = rgbTo.obj(input);
        var output = [input["r"], input["g"], input["b"]];
        if (isPresent(input["a"])) output.push(input["a"]);
        return output;
    },
    cmyk: function(input, returnType){
        var [r, g, b, a] = rgbTo.arr(input);

        r = r / 255;
        g = g / 255;
        b = b / 255;

        var k = Math.min( 1 - r, 1 - g, 1 - b );
        var c = ( 1 - r - k ) / ( 1 - k );
        var m = ( 1 - g - k ) / ( 1 - k );
        var y = ( 1 - b - k ) / ( 1 - k );

        c = Math.round( c * 100 );
        m = Math.round( m * 100 );
        y = Math.round( y * 100 );
        k = Math.round( k * 100 );

        var output = {c: c, m: m, y: y, k: k, a: a};
        if (returnType === "obj") return output;
        else return cmykTo.str(output);
    },
    hex: function(input){
        var [r, g, b, a] = rgbTo.arr(input);
        var output = `#${toHex(r)}${toHex(g)}${toHex(b)}`;
        if (isPresent(a) && a !== 1) output += toHex(a);

        return output;

        function toHex(val){
            if (val < 1) val = round(val * 255); // for alpha

            var hex = Math.max(Math.min(parseInt(val, 10), 255), 0)
            return hex > 15 ? hex.toString(16) : '0' + hex.toString(16);
        }
    },
    hsl: function(input, returnType){
        var [r, g, b, a] = rgbTo.arr(input);

        r = Math.max(Math.min(parseInt(r, 10) / 255, 1), 0);
        g = Math.max(Math.min(parseInt(g, 10) / 255, 1), 0);
        b = Math.max(Math.min(parseInt(b, 10) / 255, 1), 0);
        var max = Math.max(r, g, b);
        var min = Math.min(r, g, b);
        var l = (max + min) / 2;
        var d, h, s;

        if (max !== min) {
            d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            if (max === r) h = (g - b) / d + (g < b ? 6 : 0);
            else if (max === g) h = (b - r) / d + 2;
            else h = (r - g) / d + 4;
            h = h / 6;
        }
        else h = s = 0;

        var output = {
            h: Math.round(h * 360),
            s: Math.round(s * 100),
            l: Math.round(l * 100),
            a: a
        };

        if (returnType === "obj") return output;
        else return hslTo.str(output);
    },
    hsv: function(input, returnType){
        var [r, g, b, a] = rgbTo.arr(input);

        r = parseInt(r, 10) / 255;
        g = parseInt(g, 10) / 255;
        b = parseInt(b, 10) / 255;
        var max = Math.max(r, g, b);
        var min = Math.min(r, g, b);
        var d = max - min;
        var v = max;
        var h, s;

        if (max === 0) s = 0;
        else s = d / max;

        if (max === min) h = 0;
        else {
            switch (max) {
                case r: h = (g - b) / d + (g < b ? 6 : 0); break;
                case g: h = (b - r) / d + 2; break;
                case b: h = (r - g) / d + 4; break;
            }
            h = h / 6;
        }

        var output = {
            h: Math.round(h * 360),
            s: Math.round(s * 100),
            v: Math.round(v * 100),
            a: a
        };

        if (returnType === "obj") return output;
        else return hsvTo.str(output);
    },
    obj: function(input){
        if (isPlainObject(input)) return input;
        var [r, g, b, a] = parse(input);
        return {r:r, g:g, b:b, a:a};
    },
    pantone: function(input){
        if (!validInput(input, "rgb")) return;
        var hex = rgbTo.hex(input);
        return hexTo.pantone(hex);
    },
    str: function(obj){
        if (isString(obj)) obj = parse(obj);
        if (!objHasAll(obj, ["r", "g", "b"])) return "";
        var r = round(obj["r"], 0);
        var g = round(obj["g"], 0);
        var b = round(obj["b"], 0);
        var str = `rgb(${r}, ${g}, ${b}`;
        if (isPresent(obj["a"])) str += `, ${obj["a"]}`;
        str += ")"
        return str;
    }
};

/**
 * @alias Plastic.ColorConvert
 */
var ColorConvert = {
    dependencies: ["Helpers"],
    PantoneColors: {},
    calculateContrast: calculateContrast,
    changeOpacity: changeOpacity,
    contrast: contrast,
    contrastAdjust: adjustContrast,
    darken: darken,
    fromTo: fromTo,
    getColorType: getColorType,
    init: async function(){
        var url = `${Plastic.Load.repo}ColorConvert/PantoneColors.min.js`;
        Plastic.ColorConvert.PantoneColors = await Plastic.Load.return(url, "js", "PantoneColors");
    },
    lighten: lighten,
    luminance: luminance,
    // Conversion Methods
    cmykTo: cmykTo,
    hexTo: hexTo,
    hslTo: hslTo,
    hsvTo: hsvTo,
    pantoneTo: pantoneTo,
    rgbTo: rgbTo
}